import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';

import { useLoginBySSO } from './useLoginBySSO';

export const useSessionRestore = () => {
    const loginBySSO = useLoginBySSO();

    useEffect(() => {
        let timeout;
        const onSessionRestore = () => loginBySSO();
        // delayed version was made for waiting PAS reconnect efforts
        const onSessionRestoreDelayed = () => {
            timeout = setTimeout(onSessionRestore, 300);
        };

        dispatcher.listen('session:restore', onSessionRestoreDelayed);

        return () => {
            clearTimeout(timeout);
            dispatcher.removeListener('session:restore', onSessionRestoreDelayed);
        };
    }, [loginBySSO]);
};
